import { inject, Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { catchError, Observable, throwError, tap } from 'rxjs';
import { RestorePassword } from './restore-password.interface';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class RestorePasswordService {
  private http = inject(HttpClient);

  restorePassword(data: RestorePassword): Observable<any> {
    const url = `${environment.apiGatewayUrl}/account/change-password`;
    return this.http.post(url, data).pipe(catchError(this.handleError));
  }

  sendResetPasswordEmail(email: string): Observable<any> {
    const url = `${environment.apiGatewayUrl}/account/reset-password-email`;
    return this.http.post(url, {
      email: email,
    }).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    console.error('Error en la solicitud:', error);
    return throwError(
      () =>
        'Error en la solicitud, por favor intente más tarde o contacte con el administrador.'
    );
  }
}
